export default __webpack_public_path__ + "static/media/SWT1170.34I-32286_-17790_0.3f8cdacf.jpg";